import React, { Component } from "react";

import QAErrorList from "./QAErrorList";
import QAErrorFullList from "./QAErrorFullList";

import { withStyles } from '@material-ui/core/styles';
//import { makeStyles, withStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import ArrowLeftIcon from '@material-ui/icons/ArrowLeft';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';

class QAErrorSlide extends Component {
	constructor(props) {
        super(props);
		this.state={
			currentSegment: 0,
			showAll: false
		}
		//this.switchQaErrors = this.switchQaErrors.bind(this);
		//this.renderButons  = this.renderButons.bind(this);
		this.next = this.next.bind(this);
		this.previous = this.previous.bind(this);
		this.showAll = this.showAll.bind(this);
		this.errorsList = this.errorsList.bind(this);
		//this.badSegmentsList = this.badSegmentsList.bind(this);
    }
	
	next(){
		if(this.props.badSegments.length>this.state.currentSegment+1){
			//console.log("position: "+this.props.errors[this.state.currentSegment+1].tuNumber);
			this.props.goToSegment(this.props.badSegments[this.state.currentSegment+1].segment);
			this.setState(prevState => ({currentSegment: prevState.currentSegment+1}));
		}
	}
	previous(){
		if(this.state.currentSegment>0){
			this.props.goToSegment(this.props.badSegments[this.state.currentSegment-1].segment);
			this.setState(prevState => ({currentSegment: prevState.currentSegment-1}));
		}
	}
	
	showAll(){
		this.setState(prevState => ({showAll: !prevState.showAll}));
	}
	
	//badSegmentsList(){
	//	let list = [];
	//	this.props.badSegments.forEach((segment) => {
	//													list.push(<span style={{ cursor: "pointer" }} onClick={() => { this.props.goToSegment(segment.tuNumber); }}>{segment.tuNumber} </span>)
	//												});
	//	return list;
	//}
	
	//<Grid item xs={9}><div>Segments with errors: {this.badSegmentsList()}</div></Grid>
	errorsList(){
		if(this.state.showAll){
			let errorList=[];
			this.props.badSegments[this.state.currentSegment].errors.forEach(error => errorList.push(this.props.errors[error]));
			return errorList;
		}else{
			return [this.props.errors[this.props.badSegments[this.state.currentSegment].errors[0]]];
		}
	}
	
	//<Grid item xs={1}><div> <FormatListBulletedIcon style={{ cursor: "pointer" }} onClick={this.showAll}/> </div></Grid>
	//<Grid item xs={5}><div>Error: {this.props.badSegments[this.state.currentSegment].errors[0]+1}/{this.props.errors.length} </div></Grid>
	render() {
		return (
			<div>
			<QAErrorList errors={this.errorsList()}
						 dropdown={this.showAll}
						 goToSegment={this.props.goToSegment}/>
			<div>
			<Grid container direction="row" justifyContent="center" alignItems="center">
				<Grid item xs={1}><div className="actionIcon" onClick={this.previous}><ArrowLeftIcon/></div></Grid>
				<Grid item xs={2}><div>Segment: {this.state.currentSegment+1}/{this.props.badSegments.length} <span style={{ fontSize: "14px" }}>({this.props.badSegments[this.state.currentSegment].errors.length} errors)</span></div></Grid>
				<Grid item xs={7}></Grid>
				<Grid item xs={1}><div> <QAErrorFullList	errors={this.props.errors}
															goToSegment={this.props.goToSegment}/>
								</div>
				</Grid>
				<Grid item xs={1}><div className="actionIcon" onClick={this.next}><ArrowRightIcon/></div></Grid>
			</Grid>
			</div>
			</div>
		);
  }
};

export default (QAErrorSlide);